import {Box, Button, IconButton, Stack, Tooltip, Typography, Divider} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowLeft01Icon, PencilEdit01Icon, Refresh01Icon} from "@hugeicons/core-free-icons";

export const CampaignDetailsHeader = ({campaign, onBack, onRefresh, onEdit}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBack}><HugeiconsIcon icon={ArrowLeft01Icon}/></IconButton>
        <Box>
          <Typography variant="h5" fontWeight={600}>{campaign?.name || "Campaign"}</Typography>
          {campaign?.description &&
            <Typography fontSize={13} color="text.secondary">{campaign.description}</Typography>
          }
        </Box>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <Tooltip title="Refresh">
          <IconButton onClick={onRefresh}><HugeiconsIcon icon={Refresh01Icon} size={20}/></IconButton>
        </Tooltip>
          <Divider orientation="vertical" variant="middle" flexItem/>
        <Button
          variant="modal" color="info" size="small"
          startIcon={<HugeiconsIcon icon={PencilEdit01Icon} size={18}/>}
          onClick={onEdit}
        >
          Edit campaign
        </Button>
      </Stack>
    </Stack>
  )
}
